@if (visiblePrepurchases(); as prepurchases) {
  <app-profile-prepurchases [prepurchases]="prepurchases" />
}

@switch (state().status) {
  @case ('blocked') {
    <app-profile-orders-unverified />
  }

  @case ('loading') {
    <div class="orders-skeleton" aria-busy="true">
      @for (row of [1, 2, 3]; track row) {
        <div class="orders-skeleton__card">
          <span class="orders-skeleton__line orders-skeleton__line--title"></span>
          <span class="orders-skeleton__line orders-skeleton__line--meta"></span>
        </div>
      }
    </div>
  }

  @case ('error') {
    <div class="orders-error" role="alert">
      <p class="orders-error__text">{{ copy.LOAD_ERROR }}</p>
      <app-button variant="secondary" size="sm" (click)="retry()">{{ copy.RETRY }}</app-button>
    </div>
  }

  @case ('loaded') {
    @if (loaded(); as result) {
      @if (result.meta.total === 0) {
        <div class="orders-empty">
          <img
            ngSrc="images/logo/comunity.png"
            width="450"
            height="512"
            alt=""
            class="orders-empty__mascot"
          />
          <p class="orders-empty__title">{{ copy.EMPTY_TITLE }}</p>
          <p class="orders-empty__text">{{ copy.EMPTY_TEXT }}</p>
          <a routerLink="/tienda" class="orders-empty__cta">
            <app-icon [icon]="shoppingBagIcon" [size]="16" />
            {{ copy.EMPTY_CTA }}
          </a>
        </div>
      } @else {
        <ul class="orders-list" role="list">
          @for (order of result.data; track order.id) {
            <li class="order-card">
              <a class="order-card__link" [routerLink]="['/perfil/pedidos', order.id]">
                <span class="order-card__head">
                  <span class="order-card__number">{{ order.number }}</span>
                  <app-badge [variant]="statusVariant(order.status.key)">{{ order.status.label }}</app-badge>
                </span>
                <span class="order-card__meta">
                  @if (formatIsoDate(order.date); as date) {
                    <span class="order-card__date">{{ date }}</span>
                  }
                  <span class="order-card__kind">{{ order.kind.label }}</span>
                  <span class="order-card__items">{{ itemsLabel(order.items_count) }}</span>
                  @if (order.delivery; as delivery) {
                    <span class="order-card__delivery">
                      {{ delivery.label }}
                      @if (delivery.shop_name) {
                        <span class="order-card__shop">({{ delivery.shop_name }})</span>
                      }
                    </span>
                  }
                </span>
                <span class="order-card__foot">
                  <span class="order-card__total">{{ formatCrc(order.total) }}</span>
                  <span class="order-card__cta">{{ copy.VIEW_DETAIL }}</span>
                </span>
              </a>
            </li>
          }
        </ul>

        @if (result.meta.total_pages > 1) {
          <div class="orders-pagination">
            <app-pagination
              [currentPage]="result.meta.page"
              [totalPages]="result.meta.total_pages"
              (pageChange)="onPageChange($event)"
            />
          </div>
        }
      }
    }
  }
}
